module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch26"
    }
  }, [_c('b', [_vm._v("Hail to the Chief")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("To date, every U.S. president with a beard has been a Republican.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Only one person in ten is left-handed, but three of the past six presidents have been.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The first president to be impeached was Andrew Johnson.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('i', [_vm._v("Midnight Cowboy")]), _vm._v(" was the only X-rated movie shown to a U.S. president (Jimmy Carter) in office.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("All U.S. presidents have worn glasses, though some didn’t like wearing them in public.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("William Henry Harrison is one of two presidents to have double letters in both his first and last names. The other: Millard Fillmore.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Presidential film screenings began in 1915, when Woodrow Wilson watched "), _c('i', [_vm._v("The Birth of a Nation")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Most common presidential religious affiliation: Episcopalian, followed by Presbyterian.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Presidential candidate who ran the most times: Socialist Norman Thomas, six times.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Candidate with the most electoral and popular votes: Ronald Reagan, in 1984.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The film Lyndon B. Johnson most often requested be shown in the White House while he was in office: a 10-minute short about himself.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Herbert Hoover was the last president whose term ended on March 3. They now end on January 20.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Last U.S. president with a mustache: William Howard Taft.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("In 1963, Lyndon B. Johnson became the first Southerner to hold the office since Andrew Johnson in 1869.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b36ed368","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter26.vue
// module id = 150
// module chunks = 0